import { EXTERNAL_PLATFORMS_FETCH_BEGIN } from './action-types'

export const fetchExternalPlatforms = () => ({
  type: EXTERNAL_PLATFORMS_FETCH_BEGIN,
})
